import { Controller } from "@hotwired/stimulus"

// Controls the main slideshow editor functionality
export default class extends Controller {
  static targets = ["timeline"]
  static values = {
    configId: Number,
    selectedIndex: { type: Number, default: 0 }
  }

  connect() {
    this.bindKeyboardNavigation()
  }

  disconnect() {
    this.unbindKeyboardNavigation()
  }

  bindKeyboardNavigation() {
    this.keydownHandler = this.handleKeydown.bind(this)
    document.addEventListener("keydown", this.keydownHandler)
  }

  unbindKeyboardNavigation() {
    document.removeEventListener("keydown", this.keydownHandler)
  }

  handleKeydown(event) {
    // Don't handle if typing in an input
    if (event.target.matches("input, textarea, select")) return

    switch (event.key) {
      case "ArrowLeft":
      case "j":
        event.preventDefault()
        this.previousSegment()
        break
      case "ArrowRight":
      case "k":
        event.preventDefault()
        this.nextSegment()
        break
      case "Home":
        event.preventDefault()
        this.firstSegment()
        break
      case "End":
        event.preventDefault()
        this.lastSegment()
        break
    }
  }

  selectSegment(event) {
    const index = event.params.index
    if (index !== undefined) {
      this.selectedIndexValue = index
    }
  }

  previousSegment() {
    if (this.selectedIndexValue > 0) {
      this.navigateToSegment(this.selectedIndexValue - 1)
    }
  }

  nextSegment() {
    const segmentCards = this.element.querySelectorAll("[data-slideshow-editor-index-param]")
    if (this.selectedIndexValue < segmentCards.length - 1) {
      this.navigateToSegment(this.selectedIndexValue + 1)
    }
  }

  firstSegment() {
    this.navigateToSegment(0)
  }

  lastSegment() {
    const segmentCards = this.element.querySelectorAll("[data-slideshow-editor-index-param]")
    this.navigateToSegment(segmentCards.length - 1)
  }

  navigateToSegment(index) {
    // Find the segment card link and click it
    const segmentCard = this.element.querySelector(`[data-slideshow-editor-index-param="${index}"]`)
    if (segmentCard) {
      segmentCard.click()
    }
  }

  selectedIndexValueChanged() {
    // Update visual selection state
    this.updateSelectedState()
    // Scroll to selected segment
    this.scrollToSelected()
  }

  updateSelectedState() {
    // Remove selected state from all cards
    this.element.querySelectorAll("[data-slideshow-editor-index-param]").forEach((card, index) => {
      const isSelected = index === this.selectedIndexValue
      card.classList.toggle("border-blue-500", isSelected)
      card.classList.toggle("bg-blue-50", isSelected)
      card.classList.toggle("shadow-md", isSelected)
      card.classList.toggle("border-gray-200", !isSelected)
    })
  }

  scrollToSelected() {
    const selectedCard = this.element.querySelector(`[data-slideshow-editor-index-param="${this.selectedIndexValue}"]`)
    if (selectedCard) {
      selectedCard.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" })
    }
  }

  // Toggle the Ken Burns editor for an image
  toggleImageEditor(event) {
    // Don't follow links
    event.preventDefault()
    event.stopPropagation()

    const imageIndex = event.currentTarget.dataset.imageIndex
    const editorPanel = this.element.querySelector(`[data-image-editor="${imageIndex}"]`)
    const arrow = this.element.querySelector(`[data-editor-arrow="${imageIndex}"]`)

    if (editorPanel) {
      const isHidden = editorPanel.classList.contains("hidden")
      editorPanel.classList.toggle("hidden")

      // Rotate arrow
      if (arrow) {
        arrow.classList.toggle("rotate-180", isHidden)
      }
    }
  }
}
